// Standardized Amplitude web-event properties.
//
// Source of truth: the "web" tab of
// "Events&Properties_Schema_v2_Amplitude". Every standardized web event carries
// the constant base properties below; page-related events additionally carry
// the webpage_* family.
//
// These helpers only run client-side (Amplitude is initialised in the browser),
// but we guard for SSR just in case.

// Best-effort "where did this happen" value, derived from the current route.
// Trackers that receive an explicit entry point override this.
export const currentPageSource = (): string => {
  if (typeof window === 'undefined') return ''
  const [segment] = window.location.pathname.split('/').filter(Boolean)
  return segment || 'home'
}

// Cookiebot consent choice, mapped to the schema's user_consent value.
export const userConsentValue = (): string => {
  if (typeof window === 'undefined') return ''
  const consent = (
    window as unknown as {
      Cookiebot?: {
        consent?: {
          preferences?: boolean
          statistics?: boolean
          marketing?: boolean
        }
      }
    }
  ).Cookiebot?.consent
  if (!consent) return ''
  if (consent.preferences && consent.statistics && consent.marketing)
    return 'accept all'
  if (!consent.preferences && !consent.statistics && !consent.marketing)
    return 'necessary only'
  return 'partial'
}

export const baseWebEventProps = () => ({
  business_unit_name: 'lifesum',
  data_source: 'web',
  event_origin: 'website',
  event_version: 'v2',
  event_source: currentPageSource(),
})

export const webpageProps = (): Record<string, string> => {
  if (typeof window === 'undefined') return {}
  const params = new URLSearchParams(window.location.search)
  return {
    webpage_url: window.location.href,
    webpage_path: window.location.pathname,
    webpage_title: document.title,
    webpage_referrer: document.referrer,
    webpage_medium: params.get('utm_medium') ?? '',
    webpage_content: params.get('utm_content') ?? '',
    webpage_term: params.get('utm_term') ?? '',
    webpage_location: params.get('utm_campaign') ?? '',
  }
}
